import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetSshKeyRotationsRequestSchema,
  TGetSshKeyRotationsResponseSchema,
} from "./getSshKeyRotations.schema";

export const getSshKeyRotations = (axios: IAxiosInstance) => {
  return async (params: TGetSshKeyRotationsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetSshKeyRotationsResponseSchema>
    >("/api/sshKeyRotations", {
      params,
    });

    if (!response?.data?.success) {
      throw new Error("Something went wrong");
    }

    return response?.data?.data;
  };
};
